"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPRequestHeaders = void 0;
var tslib_1 = require("tslib");
var HTTPRequestHeaders = /** @class */ (function () {
    function HTTPRequestHeaders(init) {
        /**
         * The actual headers.
         */
        this._headers = {};
        /**
         * The number of headers present.
         */
        this._count = 0;
        this._setAll(init);
    }
    HTTPRequestHeaders.prototype._setAll = function (init) {
        var count = 0;
        for (var key in init) {
            if (!init.hasOwnProperty(key) || !init[key]) {
                continue;
            }
            this._headers[key.toLowerCase()] = init[key];
            count++;
        }
        this._count = count;
    };
    HTTPRequestHeaders.prototype.get = function (name) {
        return this._headers[name.toLowerCase()] || null;
    };
    HTTPRequestHeaders.prototype.has = function (name) {
        return !!this._headers[name.toLowerCase()];
    };
    HTTPRequestHeaders.prototype.set = function (name, value) {
        this._headers[name.toLowerCase()] = value;
        this._count++;
    };
    HTTPRequestHeaders.prototype.delete = function (name) {
        var _name = name.toLowerCase();
        if (this._headers[_name]) {
            this._count--;
        }
        delete this._headers[name.toLowerCase()];
    };
    HTTPRequestHeaders.prototype.count = function () {
        return this._count;
    };
    HTTPRequestHeaders.prototype.toJSON = function () {
        return tslib_1.__assign({}, this._headers);
    };
    return HTTPRequestHeaders;
}());
exports.HTTPRequestHeaders = HTTPRequestHeaders;
//# sourceMappingURL=request_headers.js.map